let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gWjCN")).then(() => parcelRequire('4SDb2'));